<template>
  <div class="agent-analyst">
    <sub-title title="昨日回顾"></sub-title>
    <AgentDesc :avatar-index="9" name="分析师"></AgentDesc>
    <div class="agent-analyst-body">
      <div class="agent-analyst__desc">已为你生成昨日日报，请查阅 ~</div>
      <div class="agent-analyst__content">
        <div
          ref="markdownRef"
          class="markdown-wrapper"
          :class="{ collapsed: needExpand && !expanded }"
        >
          <markdown-view :show-string="showString"></markdown-view>
        </div>
        <div v-if="needExpand && !expanded" class="expand" @click="expanded = true">
          <span>展开</span>
          <i class="icon-arrow-down-s-line t-iconfont"></i>
        </div>
        <div class="btn" @click="handleRead">
          <span class="btn__text">已阅</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, computed } from 'vue'
import subTitle from './components/sub-title.vue'
import AgentDesc from './components/agent-desc.vue'
import MarkdownView from '@/components/markdown-view/index.vue'

const props = defineProps({
  analystList: {
    type: Array,
    default: () => []
  },
  refType: {
    type: Number,
    default: 1
  }
})

const emits = defineEmits(['handleRead'])

const showString = computed(() => {
  return props.analystList[0].msg
})

const COLLAPSE_HEIGHT = 64
const needExpand = ref(false)
const expanded = ref(false)
const markdownRef = ref(null)

const handleRead = () => {
  emits('handleRead', { id: props.analystList[0].id, refType: props.refType })
}

onMounted(async () => {
  await nextTick()
  if (markdownRef.value) {
    needExpand.value = markdownRef.value.offsetHeight > COLLAPSE_HEIGHT
  }
})
</script>

<style lang="scss" scoped>
.agent-analyst {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 24px;
  &-body {
    flex: 1;
    padding-left: 32px;
    display: flex;
    flex-direction: column;
    position: relative;
  }
  &__desc {
    font-size: 13px;
    line-height: 18px;
    color: #646566;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 8px;
  }
  &__content {
    padding: 12px;
    background: linear-gradient(297deg, #eef2ff 1%, #f5f3ff 100%);
    border-radius: 16px;
    box-sizing: border-box;
    /* 拓展色/紫罗兰/Violets-1 */
    /* 样式描述：$violets-color-1 */
    border: 1px solid #f5e8ff;

    box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.05);
    .markdown-wrapper {
      margin-bottom: 8px;
      &.collapsed {
        max-height: 64px;
        overflow: hidden;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 32px;
          background: linear-gradient(to bottom, transparent, #eef2ff);
          pointer-events: none;
        }
      }
    }
    .btn {
      // 拓展色/紫罗兰/Violets-6
      $violets-6: #7a52f4;
      width: 100%;
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 64px;
      border: 1px solid $violets-6;
      box-sizing: border-box;
      padding: 8px 12px;
      &__text {
        // 五级文字/常规
        font-family: 'PingFang SC', sans-serif;
        font-size: 13px;
        font-weight: 400;
        color: $violets-6;
        text-align: center;
        cursor: pointer;
      }
    }
    .expand {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      line-height: 18px;
      color: #969799;
      margin-bottom: 12px;
      span {
        cursor: pointer;
      }
      i {
        margin-left: 4px;
        font-size: 18px;
        cursor: pointer;
      }
    }
  }
}
</style>
